import styled from '@emotion/styled';

const Subtitle = styled('div')(({ theme }) => ({
  color: theme.colors.gray['400'],
  fontSize: theme.fonts.size['12'],
}));

export default Subtitle;
